import { render, staticRenderFns } from "./TreatmentPlanObjectivesV1Properties.vue?vue&type=template&id=49515a9c&"
import script from "./TreatmentPlanObjectivesV1Properties.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanObjectivesV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports